import { useForm } from "react-hook-form";
import { loginUser, googleLoginUser } from "../helpers/apiCalls";
import MyContext from "../context/MyContext";
import { useHistory, Link } from "react-router-dom";
import React, { useContext } from "react";
import { GoogleLogin } from 'react-google-login';
import ErrorDisplay from "./ErrorDisplay";

const Login = () => {
  const { register, handleSubmit } = useForm();
  const context = useContext(MyContext);
  const { setUser, setError, setIsLogged, setAuthIsDone, setIsAdmin } = context;

  const history = useHistory();

  const onSubmit = async (userData) => {
    const res = await loginUser(userData);
    if (res.error) {
      return setError(res.error);
    }
    setError({});
    setUser(res);
    if(res.role === 1) setIsAdmin(true)
    setIsLogged(true)
    setAuthIsDone(true);
    history.push("/");
  };

  const responseGoogle = async (response) => {
    // console.log(".........", response.profileObj);
    const { email, familyName, givenName, googleId, imageUrl } = response.profileObj;
    const data = {
      email,
      googleId,
      firstName: givenName,
      lastName: familyName,
      avatar: imageUrl,
    };
    let result = await googleLoginUser(data);
    if (result.error) {
      return setError(result.error);
    }
    setError({});
    setUser(result);
    setIsLogged(true)
    history.push("/");
  };

  // if (userStatus) return <Redirect to='/dashboard' />;

  return (
    <div className="login-page">
      <h2>Login</h2>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <input
          placeholder="Email"
          // defaultValue="f@f.com"
          defaultValue="ferujahammed2020@gmail.com"
          {...register("email",{
            required: true,
            pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i},
          )}
        />
        <input
              placeholder="Password"
              type='password'
              defaultValue="123456@Aa"
              {...register('password',{
                required: true,
                min: 8,
              })}
            />

        <div className="row">
          <button type="submit">Login</button>
          <Link to="/register">Register</Link>
        </div>
      </form>
      <div className="google-login">          
      <GoogleLogin
          clientId='884341565533-nu6t3be9dr6q0bbm8c3n8v754hbjcohh.apps.googleusercontent.com'
          buttonText='Login'
          onSuccess={responseGoogle}
          onFailure={responseGoogle}
          cookiePolicy={'single_host_origin'}
        />
      </div>
      <ErrorDisplay />
    </div>
  );
};

export default Login;
